import { maskEmail as maskEmailValue } from '@cortex/domain-pii';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 観測ログに乗せる前に email のローカル部を伏字化。マスク後も「@domain」の構造は保持し、一次対応で
 *   どのドメインのアカウントだったかは追跡できるようにする（observability.md「マスク後の値と元の構造は維持」）。
 * @graph-connects none
 */
export function maskEmail(email: string): string {
  return maskEmailValue(email);
}

/**
 * URL パス中の email（`/accounts/foo@example.com`）をマスクしたパスへ置換する。
 * クエリ文字列はそのまま残す（ガイドライン: 構造は維持）。
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 観測ログ送出前に URL パス中の email ローカル部を伏字化。パス・クエリ文字列・@domain の構造は維持し、
 *   インシデント対応で対象ドメインを特定できるようにする。
 * @graph-connects none
 */
export function maskEmailInPath(path: string): string {
  return path.replace(/([^/?#]+(?:@|%40)[^/?#]+\.[^/?#]+)/g, (m: string) =>
    maskEmail(decodeURIComponent(m)),
  );
}
